/*
 * Navigation entries for the screen in use. `desktopOnly: true` leaves an
 * entry out on a phone — a page built for a keyboard and a wide screen, like
 * the fast journal's grid, is not offered where it cannot be used. Applied to
 * sub-menus too; a sub-menu left with nothing is left out as well.
 */
const visibleNavItems = (items = [], isMobile) => {
    if (!isMobile) return items
    return items
        .filter(item => !item.desktopOnly)
        .map(item => item.subNav ? { ...item, subNav: visibleNavItems(item.subNav, isMobile) } : item)
        .filter(item => !item.subNav || item.subNav.length > 0)
}

export default visibleNavItems
